// Copyright 2014-2020 The MathWorks, Inc.
define(['dojo/request/xhr', 'mw-html-utils/HtmlUtils'], function (xhr, HtmlUtils) {
    var attemptedResolution = false;
    var service = {};
    service._serviceData = {};
    service.getServiceRegistryEndpoint = function (name) {
        if (service._serviceData.serviceregistry) {
            var numServices;
            var i;
            numServices = service._serviceData.serviceregistry.length;
            for (i = 0; i < numServices; i += 1) {
                if (service._serviceData.serviceregistry[i].name === name) {
                    return service._serviceData.serviceregistry[i].endpoint;
                }
            }
        }
        return '';
    };

    var overrideDefaultRemoteEndpoint = function (serviceRegistryData) {
        var defaultRemoteEndpoint = HtmlUtils.parseQueryString()['mre'];
        if (defaultRemoteEndpoint) {
            // Since we will only allow the domain that is loading this JavaScript as a safe domain,
            // then if queryVal is just a relative URL, then use the same domain where this JavaScript is loaded
            var url = new URL(defaultRemoteEndpoint, window.location.href);
            if (_isSameDomain(url)) {
                // If same domain, then use it
                defaultRemoteEndpoint = url.href;
                var newServiceRegistry = serviceRegistryData.serviceregistry;
                newServiceRegistry = Array.isArray(newServiceRegistry) ? newServiceRegistry : [];

                /**
                 * Check if there is an endpoint called 'primary'
                 * If yes, Update it with value from mre query param
                 * If no, Add another entry into serviceregistry
                 */

                var foundPrimaryEndpoint = false;
                newServiceRegistry.forEach(entry => {
                    if (entry.name && entry.name === 'primary') {
                        entry.endpoint = defaultRemoteEndpoint;
                        foundPrimaryEndpoint = true;
                    }
                });

                if (!foundPrimaryEndpoint) {
                    newServiceRegistry.push({
                        name: 'primary',
                        endpoint: defaultRemoteEndpoint
                    });
                    // Add object back to serviceRegistryData
                    serviceRegistryData.serviceregistry = newServiceRegistry;
                }
            }
        }
        return serviceRegistryData;
    };

    var _isSameDomain = function (queryVal) {
        if (queryVal.origin === window.location.origin) {
            return true;
        }
        return false;
    };

    var result = {
        _doXhr: function (url, sync) {
            return xhr(url,
                {
                    handleAs: 'json',
                    failOk: true,
                    method: 'GET',
                    timeout: 15000,
                    sync: sync
                });
        },

        _reset: function () {
            attemptedResolution = false;
            service._serviceData = {};
        },

        load: function (id, require, callback) {
            if (attemptedResolution) {
                callback(service);
            } else {
                // Legacy Loader from 1.x does not support async - See dojo/text
                // This was failing on dojo.require("MW.remote.MessageService") type loads
                var sync = !require.async;
                result._doXhr('/serviceregistrylookup/1/service', sync).then(
                    function (json) {
                        if (!(json instanceof Object)) {
                            json = {};
                        }
                        service._serviceData = overrideDefaultRemoteEndpoint(json);
                        attemptedResolution = true;
                        callback(service);
                    },
                    function () {
                        service._serviceData = overrideDefaultRemoteEndpoint({});
                        attemptedResolution = true;
                        callback(service);
                    }
                );
            }
        }
    };
    return result;
});
